// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"1147":"2372c4895d33c6db","9960":"95712e0eb3c2afb3"}[chunkId] + ".css";
};